type FilterValue = string | number | boolean

const checkHasFilters = (
  filters: Record<string, FilterValue | FilterValue[]> | undefined | null
) => {
  return (
    !!filters &&
    Object.values(filters).some((filter) => {
      if (Array.isArray(filter)) {
        return filter.length > 0
      }

      return filter !== undefined
    })
  )
}

export default checkHasFilters
